//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import NotificationList from "../pages/Notification/NotificationList";
import ReadNotificationList from "../pages/Notification/ReadNotificationList";
import UnReadNotificationList from "../pages/Notification/UnReadNotificationList";
import NoticeList from "../pages/Notice/NoticeList";
import {
  ClientAccessControl,
  PermissionRequired,
} from "@careinfo/permission-required";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path="/notification"
          element={
            <ClientAccessControl
              allowedPermissions={["can_view_notifications"]}
              renderNoAccess={<PermissionRequired />}
            >
              <NotificationList />
            </ClientAccessControl>
          }
        />
        <Route
          path="/notification/all"
          element={
            <ClientAccessControl
              allowedPermissions={["can_view_notifications"]}
              renderNoAccess={<PermissionRequired />}
            >
              <NotificationList />
            </ClientAccessControl>
          }
        />
        <Route
          path="/notification/read"
          element={
            <ClientAccessControl
              allowedPermissions={["can_view_notifications"]}
              renderNoAccess={<PermissionRequired />}
            >
              <ReadNotificationList />
            </ClientAccessControl>
          }
        />
        <Route
          path="/notification/unread"
          element={
            <ClientAccessControl
              allowedPermissions={["can_view_notifications"]}
              renderNoAccess={<PermissionRequired />}
            >
              <UnReadNotificationList />
            </ClientAccessControl>
          }
        />
        <Route path="/notification/Notice" element={<NoticeList />} />
      </Route>
    </Routes>
  );
};

export default Router;
